import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Message } from 'primeng/api';
import { AppResource } from 'src/app/app.resource';
import { SvgVM } from 'src/app/shared/models/model/concretes/components/svg.model';
import { SvgViewerComponent } from '../svg-viewer/svg-viewer.component';

@Component({
  selector: 'app-vyv-toast',
  standalone: true,
  imports: [CommonModule, SvgViewerComponent],
  templateUrl: './vyv-toast.component.html',
})
export class VyvToastComponent {
  resource = inject(AppResource)['resource'];

  warnIcon: SvgVM;
  errorIcon: SvgVM;
  infoIcon: SvgVM;
  successIcon: SvgVM;

  constructor() {
    this.warnIcon = new SvgVM('assets/common/toast/warn.svg', 'original');
    this.errorIcon = new SvgVM('assets/common/toast/error.svg', 'original');
    this.infoIcon = new SvgVM('assets/common/toast/info.svg', 'var(--primary-color)');
    this.successIcon = new SvgVM('assets/common/toast/success.svg', 'original');
  }

  @Input() message!: Message;

  loadIcon(severity: string | undefined): SvgVM {
    switch (severity) {
      case 'warn':
        return this.warnIcon;
      case 'error':
        return this.errorIcon;
      case 'info':
        return this.infoIcon;
      case 'success':
        return this.successIcon;
      default:
        return new SvgVM(`assets/common/toast/${severity}.svg`, 'none');
    }
  }
}
